// Handle gift products on product pages - Direct Approach
document.addEventListener('DOMContentLoaded', function() {
  // Function to apply gift product styles
  function handleGiftProduct() {
    console.log("Applying gift product styles");
    
    // Add CSS to hide all possible buy buttons
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      /* Hide all possible add to cart buttons and quantity selectors */
      button[name="add"],
      .product-form__submit,
      .shopify-payment-button,
      .add-to-cart,
      .product-form__cart-submit,
      .btn--add-to-cart,
      [data-action="add-to-cart"],
      form[action$="/cart/add"] button,
      .product__submit__add,
      .product-submit,
      .add-to-cart-btn,
      .product__quantity,
      .quantity__wrapper,
      .quantity-wrapper,
      [data-quantity-wrapper],
      .product-form__quantity,
      .product-qty,
      .quantity-selector,
      .quantity-input {
        display: none !important;
      }
      
      /* Gift message styling */
      .gift-product-message {
        padding: 15px;
        margin: 15px 0;
        background-color: #f8f8f8;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-weight: 500;
      }
    `;
    document.head.appendChild(styleElement);
    
    // Add the gift message
    const giftMessage = document.createElement('div');
    giftMessage.className = 'gift-product-message';
    giftMessage.innerHTML = '<p>Šis produktas yra dovana ir negali būti įsigytas atskirai</p>';
    
    // Try different insertion points
    const insertTargets = [
      '.product-form__buttons',
      '.product-form__payment-container',
      '.product-form',
      'form[action$="/cart/add"]',
      '.product__info-container',
      '.product__info',
      '.product-single__meta',
      '.product__submit',
      '.product-single__form'
    ];
    
    // Try each potential target
    for (const selector of insertTargets) {
      const target = document.querySelector(selector);
      if (target) {
        console.log("Inserting gift message at", selector);
        target.insertBefore(giftMessage, target.firstChild);
        break;
      }
    }
  }
  
  // Function to check if this is a gift product page
  function checkIfGiftProduct() {
    // First check: URL includes "dovana-auto"
    if (window.location.pathname.includes('/products/dovana-auto')) {
      console.log("Gift product detected from URL");
      handleGiftProduct();
      return;
    }
    
    // Second check: page content includes gift product identifiers
    const pageContent = document.documentElement.innerHTML;
    if (
      pageContent.includes('template-suffix="dovana-auto"') ||
      pageContent.includes('product.dovana-auto') ||
      pageContent.includes('product--gift-item') ||
      document.querySelector('.product--gift-item')
    ) {
      console.log("Gift product detected from page content");
      handleGiftProduct();
      return;
    }
    
    // Third check: meta tags
    const metaTags = document.querySelectorAll('meta');
    for (const tag of metaTags) {
      const content = tag.getAttribute('content') || '';
      if (content.includes('dovana-auto')) {
        console.log("Gift product detected from meta tags");
        handleGiftProduct();
        return;
      }
    }
    
    // Fourth check: fetch template information directly
    // This only works on product pages
    if (window.location.pathname.includes('/products/')) {
      // Get current product handle from URL
      const pathParts = window.location.pathname.split('/');
      const productIndex = pathParts.indexOf('products');
      if (productIndex >= 0 && productIndex < pathParts.length - 1) {
        const productHandle = pathParts[productIndex + 1];
        
        fetch(`/products/${productHandle}?view=template-data`)
          .then(response => response.text())
          .then(data => {
            if (data.includes('template-suffix="dovana-auto"')) {
              console.log("Gift product detected from template-data view");
              handleGiftProduct();
            }
          })
          .catch(error => {
            console.error("Error checking template:", error);
          });
      }
    }
  }
  
  // Run on page load with a delay to ensure everything is loaded
  setTimeout(checkIfGiftProduct, 500);
  
  // Also run when page content changes
  const observer = new MutationObserver(function(mutations) {
    // If gift message already exists, don't re-run
    if (document.querySelector('.gift-product-message')) {
      return;
    }
    
    // Check if there are significant DOM changes
    let shouldCheck = false;
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && (
            node.classList.contains('product-form') ||
            node.classList.contains('product__info') ||
            node.querySelector('.product-form')
          )) {
            shouldCheck = true;
            break;
          }
        }
      }
      if (shouldCheck) break;
    }
    
    if (shouldCheck) {
      console.log("DOM changed, re-checking for gift product");
      checkIfGiftProduct();
    }
  });
  
  // Start observing the document
  observer.observe(document.documentElement, { childList: true, subtree: true });
  
  // Also run when the URL changes (for single-page applications)
  let lastUrl = window.location.href;
  window.addEventListener('popstate', function() {
    if (lastUrl !== window.location.href) {
      lastUrl = window.location.href;
      setTimeout(checkIfGiftProduct, 500);
    }
  });
});